import {
  FormControl,
  FormLabel,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";
import { colorAdapter, COLOR_OPTIONS } from "utils/color";

import ErrorMessage from "../../helpers/ErrorMessage";

interface ColorButtonSelectProps {
  label?: string;
  required?: boolean;
  disabled?: boolean;
}

const CIRCLE_SIZE = 30;

const ColorButtonSelect = ({
  label = "",
  required,
  disabled = false,
}: ColorButtonSelectProps) => {
  const field = useFieldContext<string>();

  return (
    <FormControl fullWidth disabled={disabled}>
      {label && <FormLabel required={required}>{label}</FormLabel>}

      <ToggleButtonGroup
        value={field.state.value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) field.handleChange(newValue);
        }}
        disabled={disabled}
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(8, ${CIRCLE_SIZE}px)`,
          gap: 1.5,
          justifyContent: "center",
          border: "none",
          width: "100%",
        }}
      >
        {COLOR_OPTIONS.map((color) => (
          <ToggleButton
            key={color}
            value={color}
            disableRipple
            sx={{
              width: CIRCLE_SIZE,
              height: CIRCLE_SIZE,
              minWidth: 28,
              bgcolor: colorAdapter(color),
              p: 0,
              transition: "transform 0.15s, box-shadow 0.15s",
              transform:
                field.state.value === color ? "scale(1.15)" : "scale(1)",
              boxShadow:
                field.state.value === color
                  ? (theme) =>
                      `0 0 0 2px ${theme.palette.background.paper}, 0 1px 6px 0 ${theme.palette.text.primary}`
                  : "none",
              "&:hover": {
                transform: "scale(1.15)",
                bgcolor: colorAdapter(color),
              },
              "&.Mui-selected": {
                bgcolor: colorAdapter(color),
                "&:hover": {
                  bgcolor: colorAdapter(color),
                },
              },
              "&.MuiToggleButton-root": {
                borderRadius: "50%",
                border: "none",
              },
            }}
          />
        ))}
      </ToggleButtonGroup>

      <ErrorMessage />
    </FormControl>
  );
};

export default ColorButtonSelect;
